<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="center" id="fm1" style="font-size: 150%; margin-top: 2em; margin-bottom: 5em;"><span epub:type="pagebreak" id="pageviii" title="viii"><span epub:type="pagebreak" id="page_1" title="1"><em>The Master and Margarita</em></span></span></p>
<p class="pagebreak"> </p>
<div class="poetry">
<p class="hanging">“…so who are you in the end?”</p>
<p class="hanging">“I am a part of that power which eternally desires evil and eternally does good.”</p>
<p class="hanging1">Goethe, <em>Faust</em><span href="#/OEBPS/note#ftn1" id="fnt1" title="Link target outside of Sample">*</span></p>
</div>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?2f57d8cf